import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router";

import { lightTheme, darkTheme } from '../../theme';
import { GlobalStyles } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from "@mui/material/CssBaseline";
import useMediaQuery from '@mui/material/useMediaQuery';


function ObiThemeProvider(props){
  
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  const preferedTheme = (prefersDarkMode)? 'dark':'light';
  const shouldRenderDark = (props.chosenTheme === 'dark');
  const theme = (shouldRenderDark)? darkTheme : lightTheme;

  return (
    
      <ThemeProvider theme={theme}>
        <CssBaseline/>
        <GlobalStyles
          styles={{
            body: { backgroundColor: theme.palette.background.default }
          }}
        />
        {props.children}
      </ThemeProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    chosenTheme: state.general.chosenTheme
  };
};

export default connect(mapStateToProps, {})(withRouter(ObiThemeProvider));